import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  error: null,
  previewChanges: [],
  initialRecurringOrder: null,
  mainLoading: false,
  previewModalOpened: false,
  previewModalLoading: true,
  previewModalMode: null,
  previewModalSubmitting: false,
};

// Actions
const SET_INITIAL_RECURRING_ORDER = 'recurring-orders-edit/SET_INITIAL_RECURRING_ORDER';
const SET_MAIN_LOADING = 'recurring-orders-edit/SET_MAIN_LOADING';
const SET_PREVIEW_CHANGES = 'recurring-orders-edit/SET_PREVIEW_CHANGES';
const SHOW_PREVIEW_MODAL = 'recurring-orders-edit/SHOW_PREVIEW_MODAL';
const HIDE_PREVIEW_MODAL = 'recurring-orders-edit/HIDE_PREVIEW_MODAL';
const SET_PREVIEW_SUBMITTING = 'recurring-orders-edit/SET_PREVIEW_SUBMITTING';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_INITIAL_RECURRING_ORDER](state, payload) {
    return {
      ...state,
      initialRecurringOrder: payload,
    };
  },
  [SET_MAIN_LOADING](state, payload) {
    return {
      ...state,
      mainLoading: payload,
    };
  },
  [SET_PREVIEW_CHANGES](state, payload) {
    return {
      ...state,
      previewChanges: payload,
      previewModalLoading: false,
    };
  },
  [SHOW_PREVIEW_MODAL](state, payload) {
    return {
      ...state,
      previewModalOpened: true,
      previewModalLoading: true,
      previewModalMode: payload,
    };
  },
  [HIDE_PREVIEW_MODAL](state) {
    return {
      ...state,
      previewChanges: [],
      previewModalOpened: false,
      previewModalLoading: true,
      previewModalMode: null,
    };
  },
  [SET_PREVIEW_SUBMITTING](state, payload) {
    return {
      ...state,
      previewModalSubmitting: payload,
    };
  },
});

// Action creators
export const setInitialRecurringOrder = (payload) => ({
  type: SET_INITIAL_RECURRING_ORDER,
  payload,
});

export const setMainLoading = (payload) => ({
  type: SET_MAIN_LOADING,
  payload,
});

export const setPreviewChanges = (payload) => ({
  type: SET_PREVIEW_CHANGES,
  payload,
});

export const showPreviewModalFor = (payload) => ({
  type: SHOW_PREVIEW_MODAL,
  payload,
});

export const hidePreviewModal = () => ({
  type: HIDE_PREVIEW_MODAL,
});

export const setPreviewModalSubmitting = (payload) => ({
  type: SET_PREVIEW_SUBMITTING,
  payload,
});
